import { render } from "./page-modal.vue?vue&type=template&id=2e940190&scoped=true&ts=true"
import script from "./page-modal.vue?vue&type=script&lang=ts"
export * from "./page-modal.vue?vue&type=script&lang=ts"

import "./page-modal.vue?vue&type=style&index=0&id=2e940190&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue3-admin/vue3-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e940190"]])

export default __exports__